/**
 * Web Audio API powered tiny "ping" sounds for order events.
 * No external assets required.
 *
 *   playOrderSound("execute") → pleasant 2-note ascending chirp (success)
 *   playOrderSound("reject")  → 2-note descending dull buzz (failure)
 */
let _ctx = null;

function getCtx() {
  if (_ctx) return _ctx;
  try {
    _ctx = new (window.AudioContext || window.webkitAudioContext)();
  } catch (e) {
    _ctx = null;
  }
  return _ctx;
}

function tone(freq, durationMs, type = "sine", gain = 0.18, delayMs = 0) {
  const ctx = getCtx();
  if (!ctx) return;
  const startAt = ctx.currentTime + delayMs / 1000;
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, startAt);
  g.gain.setValueAtTime(0, startAt);
  g.gain.linearRampToValueAtTime(gain, startAt + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, startAt + durationMs / 1000);
  osc.connect(g).connect(ctx.destination);
  osc.start(startAt);
  osc.stop(startAt + durationMs / 1000 + 0.05);
}

export function playOrderSound(kind) {
  if (kind === "execute") {
    // Success: A4 → E5 short ascending chirp
    tone(440, 90, "sine", 0.2, 0);
    tone(659, 130, "sine", 0.22, 90);
  } else if (kind === "reject") {
    // Reject: G3 → C3 dull descending buzz
    tone(196, 130, "triangle", 0.22, 0);
    tone(130, 180, "triangle", 0.2, 120);
  }
}
